import AppRoutes from "./app/AppRoutes";

const App = () => {
  return <AppRoutes />;
};

export default App;






